"use client";
import { useState } from "react";
import {
  Box,
  Button,
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import {
  CFormContainer,
  CFormHelperText,
  ContainedButton,
  CTextField,
  CustomFormLabel,
  GetPhoneInputStyles,
} from "./CustomStyles";
import { Poppins } from "next/font/google";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
// import { toast } from "react-toastify";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const Finish = ({ handleClose }) => {
  const [snackBar, setSnackBar] = useState(false);
  const [phoneFieldError, setPhoneFieldError] = useState(true);

  const notify = () => alert("sabbas.. you have done greate");

  const resolveWithSomeData = new Promise((resolve) =>
    setTimeout(() => resolve("world"), 3000)
  );

  return (
    <Box>
      <Box>
        {/* ==== form start ==== */}
        {/* ==== legal name ==== */}
        <Box>
          <CustomFormLabel
            sx={{ paddingBottom: "12px", fontWeight: 500, color: "#001233" }}
          >
            Legal name
          </CustomFormLabel>
          <CFormContainer component="form">
            <CTextField placeholder="First name on ID" />
            <CTextField placeholder="Last name on ID" />
            <CFormHelperText sx={{ color: "#5C677D" }}>
              Make sure this matches the name on your government ID.
            </CFormHelperText>
          </CFormContainer>
        </Box>

        {/* ==== Contact info ==== */}
        <Box sx={{ mt: 4 }}>
          <CustomFormLabel
            sx={{ padding: "12px 0px", fontWeight: 500, color: "#001233" }}
          >
            Phone
          </CustomFormLabel>
          <Box component="form">
            <PhoneInput
              country={"us"}
              countryCodeEditable={false}
              defaultErrorMessage="test"
              inputProps={GetPhoneInputStyles(phoneFieldError)}
            />
            <CFormHelperText sx={{ color: "#5C677D" }}>
              We’ll send you updates about your change.
            </CFormHelperText>
            {/* <FormHelperText>Required</FormHelperText> */}
          </Box>
        </Box>
        <ContainedButton
          variant="contained"
          fullWidth
          sx={{ mt: 4 }}
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={notify}
        >
          Agree and continue
        </ContainedButton>
        <Typography
          sx={{
            marginTop: "20px",
            fontSize: "12px",
            fontFamily: poppins.style.fontFamily,
            "& a": {
              color: "#004FE0",
              textDecoration: "none",
              fontFamily: poppins.style.fontFamily,
            },
            "& a:hover": { textDecoration: "underline" },
          }}
        >
          By continuing, I agree with Takbir's <a href="#">Terms</a> and{" "}
          <a href="#">Privacy policy</a>.
        </Typography>
      </Box>
    </Box>
  );
};

export default Finish;
